import { render } from "./MarcaCreate.vue?vue&type=template&id=389dfa82&scoped=true"
import script from "./MarcaCreate.vue?vue&type=script&lang=js"
export * from "./MarcaCreate.vue?vue&type=script&lang=js"

import "./MarcaCreate.vue?vue&type=style&index=0&id=389dfa82&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-389dfa82"]])

export default __exports__